import SimilarRooms from './SimilarRooms';

export default SimilarRooms;
